import { useMutationWithErrorHandler } from "@nens/ranalib";
import { Schematisation, getHCCApi } from "@nens/threedi/openapi-client";

import { useUpdateHccSchematisationQuery } from "@/queries/query-hcc-schematisation";

export const useUpdateSchematisationMutation = (id: number | undefined) => {
  const updateHccSchematisationQuery = useUpdateHccSchematisationQuery(id);
  return useMutationWithErrorHandler(
    (data: Partial<Schematisation>) => {
      if (!id) throw new Error("schematisationId is required");
      return getHCCApi().schematisationsPartialUpdate({ id, data });
    },
    {
      onSuccess: (result) => {
        updateHccSchematisationQuery(result);
      },
    }
  );
};
